import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-projects',
  templateUrl: './student-projects.component.html',
  styleUrls: ['./student-projects.component.scss']
})
export class StudentProjectsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
